import React from 'react';
import {useSelector} from 'react-redux';
import {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {presentationProtectionSelector} from '../../../store/selectors/presentation.selectors';
import ProtectionForm from './ProtectionForm';
import {PresentationSettingsFormType} from '../../../incase-domain/validators/presentation/presentationSchema';

interface PresentationProtectionSettingsFormProps {
    useForm: UseFormReturn<PresentationSettingsFormType>;
}

export default function PresentationProtectionSettingsForm({useForm}: PresentationProtectionSettingsFormProps): JSX.Element {
    const {t} = useTranslation();

    const {reset, watch, formState} = useForm;

    const presentation = watch('presentation');
    const protection = watch('protection');

    const presentationProtection = useSelector(presentationProtectionSelector);
    const defaultList = presentationProtection?.allowedUsers?.map((user) => ({value: user._id, label: user.email})) || [];

    return (
        <>
            <div className="c-verticalNavigation__header">
                <div className="c-verticalNavigation__header_title">{t('presEditPage.settings.presProtection.subtitle')}</div>
            </div>
            <ProtectionForm
                protection={protection}
                setProtection={(data) => reset({...{presentation}, protection: data})}
                errors={formState.errors}
                selectedAccounts={defaultList}
            />
        </>
    );
}
